/**
 * Specify a business domain scope in which the event occurred.
 */
export enum AppScope {
  GLOBAL = "global",
  AUTH = "auth",
  SOURCE_APIS = "sources_api",
  CHECKOUT_APP_API = "checkout_app_api",
  TENANT_SERVICE = "tenant_service",
  AUTH0_SERVICE = "auth0_service",
  WEB_COMPONENTS = "web_components",
}

/**
 * Specify a common group of events.
 */
export enum EventCode {
  REQUEST = "request",
  AUTHORIZATION = "authorization",
  LOGIN = "login",
  SIGNUP = "signup",
  INVALID_INPUT = "invalid_input",
  INVALID_RESPONSE = "invalid_response",
  REQUEST_FAILED = "request_failed",
  TYPE_VALIDATION_FAILED = "type_validation_failed",
  CACHE_RESET = "cache_reset",
  CACHE_CLEANUP = "cache_cleanup",
}

export enum Page {
  SEARCH = "search",
  DETAILS = "details",
  ADMIN = "/admin",
  AUTH = "/auth",
  AUTH_LOGIN = "/auth/login",
  AUTH_PROFILE = "/auth/profile",
}

export enum Language {
  EN = "en",
  FR = "fr",
}

export enum Locale {
  EN = "en-CA",
  FR = "fr-CA",
}

export const Pages = {
  [Language.EN]: {
    checkout: "checkout",
    search: "search",
    details: "details",
  },
  [Language.FR]: {
    checkout: "achat",
    search: "recherche",
    details: "détails",
  },
};
